// extracted by mini-css-extract-plugin
module.exports = {"Head":"Stock__Head_1-O9h","Title":"Stock__Title_2s7eo","Description":"Stock__Description_Jh1Hr","Chart":"Stock__Chart_1GXhf"};